import React from 'react';

const CoachingContent = () => {
  return <h2>Coaching</h2>;
};

export default CoachingContent;
